// source: v3/types/call_detail_record.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_duration_pb = require('google-protobuf/google/protobuf/duration_pb.js');
goog.object.extend(proto, google_protobuf_duration_pb);
goog.exportSymbol('proto.loopup.ctgateway.v3.CallCategorizationRule', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.CallDetailRecord', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.Direction', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.NumberDetails', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.NumberType', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.PrefixGroup', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.RegionGroup', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.CallDetailRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.CallDetailRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.CallDetailRecord.displayName = 'proto.loopup.ctgateway.v3.CallDetailRecord';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.RegionGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v3.RegionGroup.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v3.RegionGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.RegionGroup.displayName = 'proto.loopup.ctgateway.v3.RegionGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.PrefixGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v3.PrefixGroup.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v3.PrefixGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.PrefixGroup.displayName = 'proto.loopup.ctgateway.v3.PrefixGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.NumberDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.NumberDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.NumberDetails.displayName = 'proto.loopup.ctgateway.v3.NumberDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.CallCategorizationRule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.CallCategorizationRule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.CallCategorizationRule.displayName = 'proto.loopup.ctgateway.v3.CallCategorizationRule';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.CallDetailRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.CallDetailRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.CallDetailRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
    callId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    originatingDdi: jspb.Message.getFieldWithDefault(msg, 2, ""),
    terminatingDdi: jspb.Message.getFieldWithDefault(msg, 3, ""),
    connectedTime: (f = msg.getConnectedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    disconnectedTime: (f = msg.getDisconnectedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    duration: (f = msg.getDuration()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    outboundCharge: (f = msg.getOutboundCharge()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
    inboundCharge: (f = msg.getInboundCharge()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.CallDetailRecord}
 */
proto.loopup.ctgateway.v3.CallDetailRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.CallDetailRecord;
  return proto.loopup.ctgateway.v3.CallDetailRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.CallDetailRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.CallDetailRecord}
 */
proto.loopup.ctgateway.v3.CallDetailRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCallId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginatingDdi(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTerminatingDdi(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setConnectedTime(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDisconnectedTime(value);
      break;
    case 6:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setDuration(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setOutboundCharge(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setInboundCharge(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.CallDetailRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.CallDetailRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.CallDetailRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCallId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOriginatingDdi();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTerminatingDdi();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getConnectedTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDisconnectedTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDuration();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getOutboundCharge();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getInboundCharge();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string call_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.getCallId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.CallDetailRecord} returns this
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.setCallId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string originating_ddi = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.getOriginatingDdi = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.CallDetailRecord} returns this
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.setOriginatingDdi = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string terminating_ddi = 3;
 * @return {string}
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.getTerminatingDdi = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.CallDetailRecord} returns this
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.setTerminatingDdi = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp connected_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.getConnectedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.CallDetailRecord} returns this
*/
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.setConnectedTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.CallDetailRecord} returns this
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.clearConnectedTime = function() {
  return this.setConnectedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.hasConnectedTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp disconnected_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.getDisconnectedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.CallDetailRecord} returns this
*/
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.setDisconnectedTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.CallDetailRecord} returns this
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.clearDisconnectedTime = function() {
  return this.setDisconnectedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.hasDisconnectedTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Duration duration = 6;
 * @return {?proto.google.protobuf.Duration}
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.getDuration = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 6));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.loopup.ctgateway.v3.CallDetailRecord} returns this
*/
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.setDuration = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.CallDetailRecord} returns this
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.clearDuration = function() {
  return this.setDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.hasDuration = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.DoubleValue outbound_charge = 7;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.getOutboundCharge = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 7));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.CallDetailRecord} returns this
*/
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.setOutboundCharge = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.CallDetailRecord} returns this
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.clearOutboundCharge = function() {
  return this.setOutboundCharge(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.hasOutboundCharge = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.DoubleValue inbound_charge = 8;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.getInboundCharge = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 8));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.CallDetailRecord} returns this
*/
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.setInboundCharge = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.CallDetailRecord} returns this
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.clearInboundCharge = function() {
  return this.setInboundCharge(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.CallDetailRecord.prototype.hasInboundCharge = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v3.RegionGroup.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.RegionGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.RegionGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.RegionGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.RegionGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    regionsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.RegionGroup}
 */
proto.loopup.ctgateway.v3.RegionGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.RegionGroup;
  return proto.loopup.ctgateway.v3.RegionGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.RegionGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.RegionGroup}
 */
proto.loopup.ctgateway.v3.RegionGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addRegions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.RegionGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.RegionGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.RegionGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.RegionGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRegionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.RegionGroup.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.RegionGroup} returns this
 */
proto.loopup.ctgateway.v3.RegionGroup.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string regions = 2;
 * @return {!Array<string>}
 */
proto.loopup.ctgateway.v3.RegionGroup.prototype.getRegionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.loopup.ctgateway.v3.RegionGroup} returns this
 */
proto.loopup.ctgateway.v3.RegionGroup.prototype.setRegionsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v3.RegionGroup} returns this
 */
proto.loopup.ctgateway.v3.RegionGroup.prototype.addRegions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v3.RegionGroup} returns this
 */
proto.loopup.ctgateway.v3.RegionGroup.prototype.clearRegionsList = function() {
  return this.setRegionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v3.PrefixGroup.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.PrefixGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.PrefixGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.PrefixGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.PrefixGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
    prefixGroupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    prefixesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.PrefixGroup}
 */
proto.loopup.ctgateway.v3.PrefixGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.PrefixGroup;
  return proto.loopup.ctgateway.v3.PrefixGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.PrefixGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.PrefixGroup}
 */
proto.loopup.ctgateway.v3.PrefixGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrefixGroupId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addPrefixes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.PrefixGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.PrefixGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.PrefixGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.PrefixGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrefixGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrefixesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string prefix_group_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.PrefixGroup.prototype.getPrefixGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.PrefixGroup} returns this
 */
proto.loopup.ctgateway.v3.PrefixGroup.prototype.setPrefixGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string prefixes = 2;
 * @return {!Array<string>}
 */
proto.loopup.ctgateway.v3.PrefixGroup.prototype.getPrefixesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.loopup.ctgateway.v3.PrefixGroup} returns this
 */
proto.loopup.ctgateway.v3.PrefixGroup.prototype.setPrefixesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v3.PrefixGroup} returns this
 */
proto.loopup.ctgateway.v3.PrefixGroup.prototype.addPrefixes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v3.PrefixGroup} returns this
 */
proto.loopup.ctgateway.v3.PrefixGroup.prototype.clearPrefixesList = function() {
  return this.setPrefixesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.NumberDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.NumberDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.NumberDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.NumberDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    region: (f = msg.getRegion()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    regionGroup: (f = msg.getRegionGroup()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    prefix: jspb.Message.getFieldWithDefault(msg, 3, ""),
    prefixGroup: (f = msg.getPrefixGroup()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    isGeographic: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    isMobile: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    isSatellite: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.NumberDetails}
 */
proto.loopup.ctgateway.v3.NumberDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.NumberDetails;
  return proto.loopup.ctgateway.v3.NumberDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.NumberDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.NumberDetails}
 */
proto.loopup.ctgateway.v3.NumberDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRegion(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRegionGroup(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrefix(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPrefixGroup(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsGeographic(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMobile(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSatellite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.NumberDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.NumberDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.NumberDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.NumberDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRegion();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRegionGroup();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPrefix();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPrefixGroup();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getIsGeographic();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getIsMobile();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getIsSatellite();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional google.protobuf.StringValue region = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.NumberDetails.prototype.getRegion = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.NumberDetails} returns this
*/
proto.loopup.ctgateway.v3.NumberDetails.prototype.setRegion = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.NumberDetails} returns this
 */
proto.loopup.ctgateway.v3.NumberDetails.prototype.clearRegion = function() {
  return this.setRegion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.NumberDetails.prototype.hasRegion = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue region_group = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.NumberDetails.prototype.getRegionGroup = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.NumberDetails} returns this
*/
proto.loopup.ctgateway.v3.NumberDetails.prototype.setRegionGroup = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.NumberDetails} returns this
 */
proto.loopup.ctgateway.v3.NumberDetails.prototype.clearRegionGroup = function() {
  return this.setRegionGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.NumberDetails.prototype.hasRegionGroup = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string prefix = 3;
 * @return {string}
 */
proto.loopup.ctgateway.v3.NumberDetails.prototype.getPrefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.NumberDetails} returns this
 */
proto.loopup.ctgateway.v3.NumberDetails.prototype.setPrefix = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue prefix_group = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.NumberDetails.prototype.getPrefixGroup = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.NumberDetails} returns this
*/
proto.loopup.ctgateway.v3.NumberDetails.prototype.setPrefixGroup = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.NumberDetails} returns this
 */
proto.loopup.ctgateway.v3.NumberDetails.prototype.clearPrefixGroup = function() {
  return this.setPrefixGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.NumberDetails.prototype.hasPrefixGroup = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool is_geographic = 5;
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.NumberDetails.prototype.getIsGeographic = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.loopup.ctgateway.v3.NumberDetails} returns this
 */
proto.loopup.ctgateway.v3.NumberDetails.prototype.setIsGeographic = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool is_mobile = 6;
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.NumberDetails.prototype.getIsMobile = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.loopup.ctgateway.v3.NumberDetails} returns this
 */
proto.loopup.ctgateway.v3.NumberDetails.prototype.setIsMobile = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool is_satellite = 7;
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.NumberDetails.prototype.getIsSatellite = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.loopup.ctgateway.v3.NumberDetails} returns this
 */
proto.loopup.ctgateway.v3.NumberDetails.prototype.setIsSatellite = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.CallCategorizationRule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.CallCategorizationRule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: (f = msg.getDescription()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    direction: jspb.Message.getFieldWithDefault(msg, 3, 0),
    priority: (f = msg.getPriority()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    originationPrefixGroup: (f = msg.getOriginationPrefixGroup()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    originationRegionGroup: (f = msg.getOriginationRegionGroup()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    originationRegion: (f = msg.getOriginationRegion()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    originationSubRegion: (f = msg.getOriginationSubRegion()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    originationNumberType: jspb.Message.getFieldWithDefault(msg, 9, 0),
    terminationPrefixGroup: (f = msg.getTerminationPrefixGroup()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    terminationRegionGroup: (f = msg.getTerminationRegionGroup()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    terminationRegion: (f = msg.getTerminationRegion()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    terminationSubRegion: (f = msg.getTerminationSubRegion()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    terminationNumberType: jspb.Message.getFieldWithDefault(msg, 14, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.CallCategorizationRule;
  return proto.loopup.ctgateway.v3.CallCategorizationRule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.CallCategorizationRule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {!proto.loopup.ctgateway.v3.Direction} */ (reader.readEnum());
      msg.setDirection(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setPriority(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setOriginationPrefixGroup(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setOriginationRegionGroup(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setOriginationRegion(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setOriginationSubRegion(value);
      break;
    case 9:
      var value = /** @type {!proto.loopup.ctgateway.v3.NumberType} */ (reader.readEnum());
      msg.setOriginationNumberType(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTerminationPrefixGroup(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTerminationRegionGroup(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTerminationRegion(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTerminationSubRegion(value);
      break;
    case 14:
      var value = /** @type {!proto.loopup.ctgateway.v3.NumberType} */ (reader.readEnum());
      msg.setTerminationNumberType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.CallCategorizationRule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.CallCategorizationRule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPriority();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getOriginationPrefixGroup();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getOriginationRegionGroup();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getOriginationRegion();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getOriginationSubRegion();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getOriginationNumberType();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getTerminationPrefixGroup();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTerminationRegionGroup();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTerminationRegion();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTerminationSubRegion();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTerminationNumberType();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue description = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.getDescription = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
*/
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.setDescription = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.clearDescription = function() {
  return this.setDescription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.hasDescription = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Direction direction = 3;
 * @return {!proto.loopup.ctgateway.v3.Direction}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.getDirection = function() {
  return /** @type {!proto.loopup.ctgateway.v3.Direction} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v3.Direction} value
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.setDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional google.protobuf.Int32Value priority = 4;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.getPriority = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
*/
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.setPriority = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.clearPriority = function() {
  return this.setPriority(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.hasPriority = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue origination_prefix_group = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.getOriginationPrefixGroup = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
*/
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.setOriginationPrefixGroup = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.clearOriginationPrefixGroup = function() {
  return this.setOriginationPrefixGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.hasOriginationPrefixGroup = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue origination_region_group = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.getOriginationRegionGroup = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
*/
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.setOriginationRegionGroup = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.clearOriginationRegionGroup = function() {
  return this.setOriginationRegionGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.hasOriginationRegionGroup = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue origination_region = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.getOriginationRegion = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
*/
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.setOriginationRegion = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.clearOriginationRegion = function() {
  return this.setOriginationRegion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.hasOriginationRegion = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue origination_sub_region = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.getOriginationSubRegion = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
*/
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.setOriginationSubRegion = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.clearOriginationSubRegion = function() {
  return this.setOriginationSubRegion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.hasOriginationSubRegion = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional NumberType origination_number_type = 9;
 * @return {!proto.loopup.ctgateway.v3.NumberType}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.getOriginationNumberType = function() {
  return /** @type {!proto.loopup.ctgateway.v3.NumberType} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v3.NumberType} value
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.setOriginationNumberType = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional google.protobuf.StringValue termination_prefix_group = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.getTerminationPrefixGroup = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
*/
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.setTerminationPrefixGroup = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.clearTerminationPrefixGroup = function() {
  return this.setTerminationPrefixGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.hasTerminationPrefixGroup = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.StringValue termination_region_group = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.getTerminationRegionGroup = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
*/
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.setTerminationRegionGroup = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.clearTerminationRegionGroup = function() {
  return this.setTerminationRegionGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.hasTerminationRegionGroup = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue termination_region = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.getTerminationRegion = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
*/
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.setTerminationRegion = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.clearTerminationRegion = function() {
  return this.setTerminationRegion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.hasTerminationRegion = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.StringValue termination_sub_region = 13;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.getTerminationSubRegion = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 13));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
*/
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.setTerminationSubRegion = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.clearTerminationSubRegion = function() {
  return this.setTerminationSubRegion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.hasTerminationSubRegion = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional NumberType termination_number_type = 14;
 * @return {!proto.loopup.ctgateway.v3.NumberType}
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.getTerminationNumberType = function() {
  return /** @type {!proto.loopup.ctgateway.v3.NumberType} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v3.NumberType} value
 * @return {!proto.loopup.ctgateway.v3.CallCategorizationRule} returns this
 */
proto.loopup.ctgateway.v3.CallCategorizationRule.prototype.setTerminationNumberType = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * @enum {number}
 */
proto.loopup.ctgateway.v3.Direction = {
  DIRECTION_INVALID: 0,
  DIRECTION_INBOUND: 1,
  DIRECTION_OUTBOUND: 2
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v3.NumberType = {
  NUMBER_TYPE_INVALID: 0,
  NUMBER_TYPE_GEOGRAPHIC: 1,
  NUMBER_TYPE_MOBILE: 2,
  NUMBER_TYPE_NATIONAL: 3,
  NUMBER_TYPE_SHARED_COST: 4,
  NUMBER_TYPE_PREMIUM: 5,
  NUMBER_TYPE_TOLL_FREE: 6,
  NUMBER_TYPE_UNIVERSAL_INTERNATIONAL_FREEPHONE_NUMBER: 7,
  NUMBER_TYPE_EMERGENCY: 8,
  NUMBER_TYPE_SATELLITE: 9
};

goog.object.extend(exports, proto.loopup.ctgateway.v3);
